import { Coordinate } from "ol/coordinate"
import { isValue } from "./misc"

export const fileSizeToKb = (size: number) => size / 1024

export const fileSizeToMb = (size: number) => size / (1024 * 1024)

export const objToFormData = (data: Record<string | number, any>, removeEmpty: boolean = false): FormData => {
  const formData = new FormData()
  if (data) {
    Object.keys(data).forEach((key) => {
      const value = data[key]
      if ((removeEmpty && isValue(value)) || !removeEmpty) {
        if (Array.isArray(value)) {
          value.forEach((val) => {
            formData.append(key, val)
          })
        } else {
          formData.append(key, value)
        }
      }
    })
  }
  return formData
}

export const stringToCoordinates = (val: string) => {
  const pointArr = val.split(' ')
  const lat = parseFloat(pointArr[0])
  const lon = parseFloat(pointArr[1])
  return { lat, lon }
}

export const stringToPoint = (val: string) => {
  const pointStr = val.match(/(?<=\().*?(?=\))/g)[0] ?? []
  return stringToCoordinates(pointStr)
}

export const stringToPolygon = (val: string): Coordinate[] => {
  const tempPointStr = val.match(/(?<=\().*?(?=\))/g)[0] ?? []
  const pointStr = tempPointStr.slice(1)
  const pointArr = pointStr.split(', ')
  return pointArr.reduce((arr, point) => {
    const { lat, lon } = stringToCoordinates(point)
    arr.push([lat, lon])
    return arr
  }, [])
}

export const colorToString = (val: string | number[]): string => {
  if (Array.isArray(val)) {
    const [r, g, b] = val
    return `rgb(${r}, ${g}, ${b})`
  }
  return val
}
